import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Work from "@/components/Work";
import About from "@/components/About";
import Process from "@/components/Process";
import BTS from "@/components/BTS";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  // Reveal-on-scroll observer
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="bg-[#050505] text-white" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Work />
        <About />
        <Process />
        <BTS />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
